export const DEXNET_DISCOUNT = 1 // 0.8;